import { createTheme } from '@mui/material/styles';
import { designTokens } from './designTokens';

export const appTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: designTokens.color.background.app,
      paper: designTokens.color.surface.panel,
    },
    primary: {
      main: designTokens.color.repair.greenStrong,
      light: designTokens.color.repair.green,
      dark: designTokens.color.repair.greenDeep,
      contrastText: designTokens.color.text.primary,
    },
    secondary: {
      main: designTokens.color.accent.copper,
      light: designTokens.color.accent.gold,
      dark: designTokens.color.accent.copperDeep,
      contrastText: designTokens.color.text.primary,
    },
    success: {
      main: designTokens.color.feedback.success,
    },
    warning: {
      main: designTokens.color.feedback.warning,
    },
    error: {
      main: designTokens.color.feedback.error,
    },
    info: {
      main: designTokens.color.feedback.info,
    },
    text: {
      primary: designTokens.color.text.primary,
      secondary: designTokens.color.text.secondary,
      disabled: designTokens.color.text.disabled,
    },
    divider: `rgb(${designTokens.color.border.subtleRgb} / 0.24)`,
  },
  shape: {
    borderRadius: designTokens.radius.md,
  },
  typography: {
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    button: {
      letterSpacing: 0,
      textTransform: 'none',
      fontWeight: 700,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: designTokens.color.background.app,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          borderColor: `rgb(${designTokens.color.border.subtleRgb} / 0.24)`,
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: designTokens.radius.md,
          minHeight: designTokens.action.heightMd,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: designTokens.radius.md,
          backgroundColor: `rgb(${designTokens.color.surface.inputRgb} / 0.72)`,
        },
        notchedOutline: {
          borderColor: `rgb(${designTokens.color.border.defaultRgb} / 0.36)`,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: designTokens.color.text.muted,
        },
      },
    },
  },
});

export default appTheme;
